<template>
  <div class="plan-update">
    <form class="plan-update--form" @submit.prevent="update">
      <h1>
        {{ this.item.name }}
      </h1>
      <field :errors="errors" :required="true" model="plan" name="name" v-model="item.name" placeholder="STARTER"></field>
      <field :errors="errors" :required="true" model="plan" name="price" v-model="item.price" placeholder="249.99"></field>

      <accordion :defaultActive="false" title="ui.pages.plan-rules">
        <component :is="accordionOne" v-bind="accordionOneProps"></component>
      </accordion>
      <accordion title="ui.pages.plan-organizations">
        <component :is="accordionTwo" v-bind="accordionTwoProps"></component>
      </accordion>

      <page-saver @save="update" @cancel="cancel"/>
    </form>
  </div>
</template>
<script>
import Api from '@/api/Plan.js'
import Ui from '@/classes/Ui'
import Accordion from '@/components/helpers/DataDisplay/Accordion'
import PlanRuleList from '@/components/pages/plans/PlanRuleList'
import PlanOrganizationList from '@/components/pages/plans/PlanOrganizationList'
import {updateMixin} from '@/components/mixins/Update'
import PageSaver from '@/components/helpers/Layout/PageSaver'

export default {
  mixins: [
    updateMixin
  ],
  components: {
    PlanRuleList,
    PlanOrganizationList,
    PageSaver,
    Accordion
  },
  data(){
    return {
      model: "plans",
      api: new Api(),
      name: "plan",
      errors: [],
      accordionOne: 'PlanRuleList',
      accordionTwo: 'PlanOrganizationList',
    }
  },
  computed: {
    accordionOneProps() {
      return { rules: this.item.rules }
    },
    accordionTwoProps() {
      return { organizations: this.item.organizations }
    },
  },
  mounted() {
    this.init()
    Ui.clearHeaderButtons()
    this.setHeaderButtons()
  },
  methods: {
    setHeaderButtons() {
      Ui.setPageLevel(3)
      Ui.setSubtitle({
        link: { name: "plans", path: "/plans" }
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// PlanUpdate.vue?22599b77